
import { UsageRecord } from '../../types';
import { KEYS, get, set } from '../core';

// Local storage functions
export const getUsageRecords = (): UsageRecord[] => get<UsageRecord>(KEYS.USAGE_RECORDS);
export const setUsageRecords = (records: UsageRecord[]): void => set(KEYS.USAGE_RECORDS, records);
